<script lang="ts" setup>
	const props = defineProps<{
		timeStamp: string | null
		completedTime: Date | null
		stop?: boolean
	}>()

	const startDate = computed(() => {
		return props.timeStamp ? new Date(props.timeStamp) : 0
	})

	const countdown = reactive({
		day: {
			value: 0,
			label: 'Day'
		},
		hour: {
			value: 0,
			label: 'Hour'
		},
		min: {
			value: 0,
			label: 'Min'
		},
		sec: {
			value: 0,
			label: 'Sec'
		}
	})

	const updateTimer = () => {
		const currentTime = new Date()
		if (!startDate.value) {
			return null
		}

		let difference = 0
		let seconds = 0
		let minutes = 0
		let hours = 0
		let days = 0

		if (props.completedTime && startDate.value && props.stop) {
			const updatedTime = props.completedTime
			const started = startDate.value
			difference = updatedTime.getTime() - started.getTime()
		} else {
			difference = currentTime.getTime() - startDate.value.getTime()
		}
		seconds = Math.floor((difference / 1000) % 60)
		minutes = Math.floor((difference / (1000 * 60)) % 60)
		hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
		days = Math.floor(difference / (1000 * 60 * 60 * 24))

		countdown.day.value = days
		countdown.day.label = days > 1 ? 'days' : 'day'
		countdown.hour.value = hours || 0
		countdown.hour.label = hours > 1 ? 'hours' : 'hour'
		countdown.min.value = minutes || 0
		countdown.min.label = minutes > 1 ? 'minutes' : 'minute'
		countdown.sec.value = seconds || 0
		countdown.sec.label = seconds > 1 ? 'seconds' : 'second'
	}

	onMounted(() => {
		let startTimer: NodeJS.Timeout | null = null
		if (!props.stop) {
			startTimer = setInterval(updateTimer, 1000)
		}
		if (props.stop || props.completedTime) {
			if (startTimer) {
				clearInterval(startTimer)
			}
			updateTimer()
		}
	})
</script>

<template>
	<div>
		<div class="my-5 inline-flex min-h-[70px] flex-col rounded border border-purple-200 bg-purple-25 p-2 sm:my-0">
			<h5 class="text-[10px] font-medium tracking-wide text-slate-600"> Claims Time </h5>

			<div class="mt-2 flex items-center gap-x-2">
				<div v-for="(item, key, i) in countdown" :key="key" class="inline-flex gap-x-2">
					<div class="flex flex-col items-center">
						<div class="flex h-6 w-6 items-center justify-center rounded bg-purple-500">
							<span class="text-center text-xs font-semibold text-white">
								{{ item.value }}
							</span>
						</div>
						<span class="text-[8px]">{{ item.label }}</span>
					</div>
					<span v-if="i + 1 !== Object.keys(countdown).length">:</span>
				</div>
			</div>
		</div>
	</div>
</template>
